import { Editor, Element, Node, Path, Transforms } from 'slate';
import { NESTED_LIST_PATH_INDEX } from "../constants.js";
import { getListType, getPrevSibling } from "../lib/index.js";

/**
 * Increases nesting depth of "list-item" at a given Path.
 */
export function increaseListItemDepth(editor, listItemPath) {
  var previousListItem = getPrevSibling(editor, listItemPath);

  if (!previousListItem) {
    // The existence of previous "list-item" is necessary and sufficient for the operation to be possible.
    // See: https://en.wikipedia.org/wiki/Necessity_and_sufficiency
    return;
  }

  var [previousListItemNode, previousListItemPath] = previousListItem;

  if (!editor.isListItemNode(previousListItemNode)) {
    // Sanity check.
    return;
  }

  var previousListItemChildListPath = [...previousListItemPath, NESTED_LIST_PATH_INDEX];
  var previousListItemHasChildList = Node.has(editor, previousListItemChildListPath);
  Editor.withoutNormalizing(editor, () => {
    // Ensure there's a nested "list" in the previous sibling "list-item".
    if (!previousListItemHasChildList) {
      var listNodePath = Path.ancestors(listItemPath, {
        reverse: true
      })[0];
      var listNode = Node.get(editor, listNodePath);
      Transforms.insertNodes(editor, editor.createListNode(getListType(editor, listNode), {
        children: []
      }), {
        at: previousListItemChildListPath
      });
    }

    var previousListItemChildList = Node.get(editor, previousListItemChildListPath);

    if (Element.isElement(previousListItemChildList) && editor.isListNode(previousListItemChildList)) {
      var index = previousListItemHasChildList ? previousListItemChildList.children.length : 0;
      Transforms.moveNodes(editor, {
        at: listItemPath,
        to: [...previousListItemChildListPath, index]
      });
    }
  });
}